import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setPopup } from "../../actions/parts";
import { DEFAULT_DIRECTION, POPUP_HEIGHT } from "./config";
import "./style.css";

/**
 * @name PartPopup
 * @function
 * @returns {JSX}
 * @description Displays the hover information for a product
 */
const PartPopup = () => {
  const classes = [ 'part__popup' ];
  const { coords, part, id } = useSelector( (state) => state.parts.popup );
  const dispatch = useDispatch();
  const [ direction, setDirection ] = useState( DEFAULT_DIRECTION );
  const [ left, setLeft ] = useState( 0 );
  const [ top, setTop ] = useState( 0 );

  /**
   * Calculates and updates the top of part specific popup
   */
  const updatePopupPosition = useCallback( () => {
    if ( coords && coords instanceof DOMRect ) {      
      const {
        top: partTop,
        bottom: partBottom,
        left: partLeft,
        right: partRight,
        height: partHeight,
      } = coords;
      const { innerHeight: screenHeight } = window;

      let direction = DEFAULT_DIRECTION;
      let newLeft = partRight - 20;
      let newTop = partBottom - ( partHeight / 2 ) - ( POPUP_HEIGHT / 2 );

      // Preventing the popup from being cut-off at screen bottom
      if ( ( newTop + POPUP_HEIGHT ) > screenHeight ) {
        direction = 'top';
        newLeft = partLeft;
        newTop = partTop - POPUP_HEIGHT - 5;
      }
      setDirection( direction );
      setLeft( newLeft );
      setTop( newTop );
    }
  }, [ coords ] );

  useEffect( updatePopupPosition, [ updatePopupPosition ]);

  // Modifiers
  classes.push( `${classes[ 0 ]}--${direction}` );

  return (
    <div
      className={ classes.join( ' ' ) }
      style={ {
        display: part && part.model ? "block" : "none",
        left: `${left}px`,
        top: `${top}px`,
      } }
      onMouseEnter={() => dispatch(setPopup(coords, id))}
      onMouseLeave={() => dispatch(setPopup())}
    >
      <div className="part__popup__img">
        <img 
          src={part ? part.thumbnail : ""}
          alt={part ? part.model : ""}
          width="100%"
          height="100%"
        />
      </div>
    </div>
  );
};

export default PartPopup;